module.exports = __webpack_public_path__ + "img/logoBlanco.5891e202.svg";